const SUPER_ADMIN_PERMISSION = 'superAdmin';

type TokenPermissions = {
  permissions?: readonly string[];
};

export function isSuperAdminToken(token: TokenPermissions | null | undefined): boolean {
  return token?.permissions?.includes(SUPER_ADMIN_PERMISSION) === true;
}
